export default __webpack_public_path__ + "23d1721.png";